import { Typography } from "@mui/material";
import { ClipConfigProps, ClipStepsControlProps } from "../../clip-menu";
import { BoundaryToolProps } from "./define-boundary";

export const BoundaryComponent = (
  props: ClipConfigProps & ClipStepsControlProps & BoundaryToolProps
) => {
  return <Typography variant="body2">Coming soon!</Typography>;
};
